import { FC, useState } from "react";
import toast from "react-hot-toast";
import { reconfirmReservation } from "../../../services/Reservations.service";
import { resolveError } from "../../../utils/apiErrorMessage";
import { errorCode } from "../../../utils/reservations/cancellation";
import { reconfirmRefusalSentence } from "../../../utils/reservations/cancellationText";
import Button from "../../ui/Button";
import InfoTip from "./InfoTip";

// The only undo of a cancellation: it takes back the latest one while its refund is still on
// hold. The server refuses with a code, and each code reads as its own sentence.
const ReconfirmAction: FC<{ uniqueJourneyId: string; onDone: () => void }> = ({
  uniqueJourneyId,
  onDone
}) => {
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [refusal, setRefusal] = useState<string | null>(null);

  const reconfirm = async () => {
    setBusy(true);
    setRefusal(null);
    try {
      await reconfirmReservation(uniqueJourneyId);
      toast.success("Rezervimi u rikonfirmua.");
      onDone();
    } catch (err) {
      const status = (err as { response?: { status?: number } })?.response?.status;
      setRefusal(
        status === 409
          ? reconfirmRefusalSentence(errorCode(err))
          : resolveError(err, "Rezervimi nuk u rikonfirmua. Provoni përsëri.")
      );
    } finally {
      setBusy(false);
      setConfirming(false);
    }
  };

  return (
    <div className="flex flex-col items-end gap-1 max-w-md">
      {confirming ? (
        <div className="flex items-center gap-2 text-xs text-gray-700">
          <span>Rikonfirmo?</span>
          <InfoTip text="Anulimi i fundit zhbëhet dhe rimbursimi i tij nuk paguhet." />
          <Button padding="px-2 py-1" className="text-xs" disabled={busy} onClick={reconfirm}>
            {busy ? "Duke kryer…" : "Po, rikonfirmo"}
          </Button>
          <Button btnType="custom" padding="px-2 py-1" className="border border-gray-300 text-xs"
            disabled={busy} onClick={() => setConfirming(false)}>
            Jo
          </Button>
        </div>
      ) : (
        <Button btnType="custom" padding="px-2 py-1" className="border border-gray-400 text-xs"
          onClick={() => setConfirming(true)}>
          Rikonfirmo rezervimin
        </Button>
      )}
      {refusal && <p role="alert" className="text-xs text-red-700 text-right">{refusal}</p>}
    </div>
  );
};

export default ReconfirmAction;
